import React, { useState } from "react";
import { errorNotification } from "../../Generic/Notifications";
import { Container, Divider, InputContain, Column, Span } from "../GodMode";
import Button from "../../Generic/Button";
import InputBox from "../../Generic/InputBox";
import Card from "../../Generic/Card";
import Dropdown from "../../Generic/Dropdown";

const GantryInputClass = "gantry-inputs";
const PlatePickInputClass = "plate-pick-inputs";
const GantryTasks = {
	MOVE_ROBOT: "MOVE_ROBOT",
	PICK_PLATE_FROM_PPR: "PICK_PLATE_FROM_PPR",
	PICK_PLATE_FROM_EPR: "PICK_PLATE_FROM_EPR",
	RECOVER: "RECOVER",
	X_HOMING: "X_HOMING",
	Y_HOMING: "Y_HOMING",
	Z_HOMING: "Z_HOMING",
	A_HOMING: "A_HOMING",
	AUTO_HOME: "AUTO_HOME",
	CLEAR_ERROR: "CLEAR_ERROR",
	MOVE_TO_Level0_Docking_Safe_position: "MOVE_TO_Level0_Docking_Safe_position",
	MOVE_TO_Level1_Docking_Safe_position: "MOVE_TO_Level1_Docking_Safe_position",
	MOVE_TO_CLEANING_POSITION: "MOVE_TO_CLEANING_POSITION",
	AUTO_ZERO: "AUTO_ZERO",
};

const GANTRY_TASKS_CONFIG = {
	[GantryTasks.MOVE_ROBOT]: { 
		taskType: "move_collector_to_coordiate", 
		name: "Move Robot" 
	},
	[GantryTasks.PICK_PLATE_FROM_PPR]: { 
		taskType: "pick_plate", 
		name: "Pick Plate from PPR" 
	},
	[GantryTasks.PICK_PLATE_FROM_EPR]: { 
		taskType: "pick_plate_from_epr", 
		name: "Pick Plate from EPR" 
	},
	[GantryTasks.RECOVER]: { 
		taskType: "recover", 
		name: "Recover" 
	},
	[GantryTasks.X_HOMING]: { 
		taskType: "home_x", 
		name: "X Homing" 
	},
	[GantryTasks.Y_HOMING]: { 
		taskType: "home_y", 
		name: "Y Homing" 
	},
	[GantryTasks.Z_HOMING]: { 
		taskType: "home_z", 
		name: "Z Homing" 
	},
	[GantryTasks.A_HOMING]: { 
		taskType: "home_a", 
		name: "A Homing" 
	},
	[GantryTasks.AUTO_HOME]: { 
		taskType: "auto_home", 
		name: "Auto Home" 
	},
	[GantryTasks.CLEAR_ERROR]: { 
		taskType: "clear_collector_error", 
		name: "Clear Error" 
	},
	[GantryTasks.MOVE_TO_Level0_Docking_Safe_position]: { 
		taskType: "move_collector_to_level_0_position", 
		name: "Move to Level 0 Docking Safe Position" 
	},
	[GantryTasks.MOVE_TO_Level1_Docking_Safe_position]: { 
		taskType: "move_collector_to_level_1_position", 
		name: "Move to Level 1 Docking Safe Position" 
	},
	[GantryTasks.MOVE_TO_CLEANING_POSITION]: { 
		taskType: "move_collector_to_cleaning_position", 
		name: "Move to Cleaning Position" 
	},
	[GantryTasks.AUTO_ZERO]: { 
		taskType: "auto_zero", 
		name: "Auto Zero" 
	},
};

const CleaningPointToGantryPoint = {
	CLEANING_1_POSITION: "CLEANING_1_POSITION",
	CLEANING_2_POSITION: "CLEANING_2_POSITION",
	CLEANING_3_POSITION: "CLEANING_3_POSITION",
	CLEANING_4_POSITION: "CLEANING_4_POSITION",
};

const CleaningPositionDropdownOptions = [
	{
		head: "Cleaning Position 1",
		value: CleaningPointToGantryPoint.CLEANING_1_POSITION,
	},
	{
		head: "Cleaning Position 2",
		value: CleaningPointToGantryPoint.CLEANING_2_POSITION,
	},
	{
		head: "Cleaning Position 3",
		value: CleaningPointToGantryPoint.CLEANING_3_POSITION,
	},
	{
		head: "Cleaning Position 4",
		value: CleaningPointToGantryPoint.CLEANING_4_POSITION,
	},
];

const axisOptions = [
	{ head: "X Axis", value: "X" },
	{ head: "Y Axis", value: "Y" },
	{ head: "Z Axis", value: "Z" },
	{ head: "A Axis", value: "R" },	
];

const Gantry = ({ sendTask, loadingStates }) => {
	const [cleaningPoint, setCleaningPoint] = useState(null);
	const [selectedAxis, setSelectedAxis] = useState(null);

	const isRecoverLoading = loadingStates[GANTRY_TASKS_CONFIG[GantryTasks.RECOVER].taskType] || false;
	const isAutoHomeLoading = loadingStates[GANTRY_TASKS_CONFIG[GantryTasks.AUTO_HOME].taskType] || false;
	const isClearErrorLoading = loadingStates[GANTRY_TASKS_CONFIG[GantryTasks.CLEAR_ERROR].taskType] || false;
	const isLevel0Loading = loadingStates[GANTRY_TASKS_CONFIG[GantryTasks.MOVE_TO_Level0_Docking_Safe_position].taskType] || false;
	const isLevel1Loading = loadingStates[GANTRY_TASKS_CONFIG[GantryTasks.MOVE_TO_Level1_Docking_Safe_position].taskType] || false;
	const isAutoZeroLoading = loadingStates[GANTRY_TASKS_CONFIG[GantryTasks.AUTO_ZERO].taskType] || false;
	const isMoveRobotLoading = loadingStates[GANTRY_TASKS_CONFIG[GantryTasks.MOVE_ROBOT].taskType] || false;
	const isPickPlatePPRLoading = loadingStates[GANTRY_TASKS_CONFIG[GantryTasks.PICK_PLATE_FROM_PPR].taskType] || false;
	const isPickPlateEPRLoading = loadingStates[GANTRY_TASKS_CONFIG[GantryTasks.PICK_PLATE_FROM_EPR].taskType] || false;
	const isMoveToCleaningLoading = loadingStates[GANTRY_TASKS_CONFIG[GantryTasks.MOVE_TO_CLEANING_POSITION].taskType] || false;

	function getPlatePickPayload() {
		let platePickPayload = {};
		const inputElements = document.getElementsByClassName(PlatePickInputClass);
		[...inputElements].forEach((input) => {
			let { id, value, valueAsNumber } = input;
			if (valueAsNumber || value) {
				platePickPayload[id] = valueAsNumber || value;
			}
		});
		return platePickPayload;
	}

	function getGantryPayload() {
		let payload = {};
		const inputElements = document.getElementsByClassName(GantryInputClass);
		[...inputElements].forEach((input) => {
			let { id, value, valueAsNumber } = input;
			if (valueAsNumber || value) {
				const [axis, key] = id.split("-");
				//Set the data
				if (payload.hasOwnProperty(axis)) {
					payload[axis][key] = valueAsNumber || value;
				} else {
					payload = {
						...payload,
						[axis]: {
							[key]: valueAsNumber || value,
						},
					};
				}
			}
		});
		return payload;
	}

	async function moveGantryRequest() {
		const payload = getGantryPayload();
		await sendTask(GANTRY_TASKS_CONFIG[GantryTasks.MOVE_ROBOT], payload);
	}

	async function pickPlateRequest(taskType) {
		//TODO: Make all forms config based.
		const platePickFields = [
				{ id: "moduleId", name: "Module", isRequired: true },
				{ id: "systemId", name: "System", isRequired: true },
			],
			payload = getPlatePickPayload();

		for (const field of platePickFields) {
			const { id, name, prefix, isRequired } = field;
			if (isRequired && !payload[id]) {
				errorNotification(`${name} needed`);
				return;
			}
			if (prefix) payload[id] = prefix + payload[id];
		}

		await sendTask(GANTRY_TASKS_CONFIG[taskType], payload);
	}

	async function moveToCleaningPosition(cleaningPoint) {
		if (!cleaningPoint) {
			errorNotification("No Cleaning Position Selected");
			return;
		}
		await sendTask(GANTRY_TASKS_CONFIG[GantryTasks.MOVE_TO_CLEANING_POSITION], { cleaningPoint });
	}

	const handleRecover = async () => {
		await sendTask(GANTRY_TASKS_CONFIG[GantryTasks.RECOVER], {});
	};

	const handleAutoHome = async () => {
		await sendTask(GANTRY_TASKS_CONFIG[GantryTasks.AUTO_HOME], {});
	};

	const handleClearError = async () => {
		await sendTask(GANTRY_TASKS_CONFIG[GantryTasks.CLEAR_ERROR], {});
	};

	const handleLevel0 = async () => {
		await sendTask(GANTRY_TASKS_CONFIG[GantryTasks.MOVE_TO_Level0_Docking_Safe_position], {});
	};

	const handleLevel1 = async () => {
		await sendTask(GANTRY_TASKS_CONFIG[GantryTasks.MOVE_TO_Level1_Docking_Safe_position], {});
	};

	const handleAutoZero = async () => {
		await sendTask(GANTRY_TASKS_CONFIG[GantryTasks.AUTO_ZERO], { axis: selectedAxis });
	};

	const handlePickPlatePPR = async () => {
		await pickPlateRequest(GantryTasks.PICK_PLATE_FROM_PPR);
	};

	const handlePickPlateEPR = async () => {
		await pickPlateRequest(GantryTasks.PICK_PLATE_FROM_EPR);
	};

	return (
		<>
			<Container>
				<Button onClick={handleRecover} disabled={isRecoverLoading}>Recover</Button>
				<Button onClick={handleAutoHome} disabled={isAutoHomeLoading}>Auto Home</Button>
				<Button onClick={handleClearError} disabled={isClearErrorLoading}>Clear Error</Button>
				<Button onClick={handleLevel0} disabled={isLevel0Loading}>
					Level 0 docking safe position
				</Button>
				<Button onClick={handleLevel1} disabled={isLevel1Loading}>
					Level 1 docking safe position
				</Button>
			</Container>

			<Container>
				<InputContain width="max-content" margin="0">
					<Dropdown
						heightVal="48px"
						widthVal="16rem"
						head="Select Axis"
						optionsList={axisOptions}
						onChange={setSelectedAxis}
						value={selectedAxis}
					/>
				</InputContain>
				<Button 
					onClick={handleAutoZero}
					disabled={!selectedAxis || isAutoZeroLoading}
				>
					Auto Zero
				</Button>
			</Container>

			<Container>
				<InputContain width="max-content" margin="0" >
					<Dropdown
						heightVal="48px"
						widthVal="16rem"
						head="Select an Option"
						optionsList={CleaningPositionDropdownOptions}
						onChange={setCleaningPoint}
						value={cleaningPoint}
					/>
				</InputContain>
				<Button onClick={() => moveToCleaningPosition(cleaningPoint)} disabled={isMoveToCleaningLoading}>Move to Cleaning Position</Button>
			</Container>

			<Divider />

			<Container>
				<Card padding="1rem">
					<h2>X Goal Position</h2>
					<InputContain>
						<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
							Target Value [mm]
						</Span>
						<InputBox className={GantryInputClass} type="number" required id="x-coordinates" />
					</InputContain>
					<InputContain>
						<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
							Target Speed [rpm]
						</Span>
						<InputBox className={GantryInputClass} type="number" required id="x-rpm" />
					</InputContain>
					<InputContain>
						<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
							Target Acc [ms]
						</Span>
						<InputBox className={GantryInputClass} type="number" required id="x-accTime" />
					</InputContain>
				</Card>
				<Card padding="1rem">
					<h2>Y Goal Position</h2>
					<InputContain>
						<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
							Target Value [mm]
						</Span>
						<InputBox className={GantryInputClass} type="number" required id="y-coordinates" />
					</InputContain>
					<InputContain>
						<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
							Target Speed [rpm]
						</Span>
						<InputBox className={GantryInputClass} type="number" required id="y-rpm" />
					</InputContain>
					<InputContain>
						<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
							Target Acc [ms]
						</Span>
						<InputBox className={GantryInputClass} type="number" required id="y-accTime" />
					</InputContain>
				</Card>
				<Card padding="1rem">
					<h2>Z Goal Position</h2>
					<InputContain>
						<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
							Target Value [mm]
						</Span>
						<InputBox className={GantryInputClass} type="number" required id="z-coordinates" />
					</InputContain>
					<InputContain>
						<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
							Target Speed [rpm]
						</Span>
						<InputBox className={GantryInputClass} type="number" required id="z-rpm" />
					</InputContain>
					<InputContain>
						<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
							Target Acc [ms]
						</Span>
						<InputBox className={GantryInputClass} type="number" required id="z-accTime" />
					</InputContain>
				</Card>
				<Card padding="1rem">
					<h2>A Goal Position</h2>
					<InputContain>
						<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
							Target Value [mm]
						</Span>
						<InputBox className={GantryInputClass} type="number" required id="r-coordinates" />
					</InputContain>
					<InputContain>
						<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
							Target Speed [rpm]
						</Span>
						<InputBox className={GantryInputClass} type="number" required id="r-rpm" />
					</InputContain>
					<InputContain>
						<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
							Target Acc [ms]
						</Span>
						<InputBox className={GantryInputClass} type="number" required id="r-accTime" />
					</InputContain>
				</Card>
				<Button onClick={moveGantryRequest} disabled={isMoveRobotLoading}>Move Robot</Button>
			</Container>

			<Divider />

			<Container>
				<Card padding="1rem" alignItems="">
					<h2>PPR POINT DETAILS</h2>
					<Container>
						<InputContain width="max-context">
							<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
								Module
							</Span>
							<InputBox type="number" className={PlatePickInputClass} required id="moduleId" />
						</InputContain>
						<InputContain width="max-context">
							<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
								System
							</Span>
							<InputBox type="number" className={PlatePickInputClass} required id="systemId" />
						</InputContain>
						<InputContain width="max-context" flexDirection="column">
							<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
								X Value
							</Span>
							<InputBox type="number" className={PlatePickInputClass} id="x" />
						</InputContain>
						<InputContain width="max-context" flexDirection="column">
							<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
								Y Value
							</Span>
							<InputBox type="number" className={PlatePickInputClass} id="y" />
						</InputContain>
						<InputContain width="max-context" flexDirection="column">
							<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
								Z Value
							</Span>
							<InputBox type="number" className={PlatePickInputClass} id="z" />
						</InputContain>
						<InputContain width="max-context" flexDirection="column">
							<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
								A Value
							</Span>
							<InputBox type="number" className={PlatePickInputClass} id="r" />
						</InputContain>
						<InputContain width="max-context" flexDirection="column">
							<Span padding="0 0 0.5rem 0.2rem" fontSize="1rem" fontWeight="600">
								Height To Go Up By
							</Span>
							<InputBox type="number" className={PlatePickInputClass} id="h" />
						</InputContain>
					</Container>
				</Card>
				<Column>
					<Button
						onClick={handlePickPlatePPR}
						disabled={isPickPlatePPRLoading}>
						Pick Plate from PPR
					</Button>
					<Button
						onClick={handlePickPlateEPR}
						disabled={isPickPlateEPRLoading}>
						Pick Plate from EPR
					</Button>
				</Column>
			</Container>
		</>
	);
};

export default Gantry;
